import Vue from 'vue'
import Vuex from 'vuex'
import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import 'firebase/compat/firestore';
import { getDatabase, ref, set ,onValue} from "firebase/database";
//import { getDatabase } from "firebase/database";

Vue.use(Vuex)
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    scores:[],
    totalEntries:0,
    locations:[],
    names:[],
    playMode:"disconnected",
    connectionWEB:false,
    connectionOSC:false,
    gameState:"",
    buttonState:"",
    levels:[]
  },
  mutations: {
    setConnectionWEB(state,payload){
      state.connectionWEB=payload
    },
    setConnectionOSC(state,payload){
      state.connectionOSC=payload
    },
    setGameState(state,payload){
      state.gameState=payload
    },
    setButtonState(state,payload){
      state.gameState=payload
    },
    setScores(state,payload){
      state.scores=payload
    },
    setLevels(state,payload){
      state.levels=payload
    },
    addPlayer(state,payload){
      if(state.names.includes(payload.Name)){

      }else{
        state.names.push(payload.Name)
      }
      
    },
    setLocations(state,payload){
      state.locations=payload
    },
    setNames(state,payload){
      state.names=payload
    },
    addLocation(state,payload){
      state.locations.push(payload)
    },
    setTotalEntries(state,payload){
      state.totalEntries=payload
    }
   
  },
  actions: {
    setDifficulty({commit},difficulty){
      const db = getDatabase();
      set(ref(db, 'TableState/Difficulty'), parseInt(difficulty,10));
    },
    triggerBallIn(){
      const db = getDatabase();
      const ballInRef = ref(db, 'TableState/BallIn');
      set(ballInRef, true);
      setTimeout(() => {
        set(ballInRef, false);
      }, 250);
    },
    setGameState({commit},state){
      const db = getDatabase();
      set(ref(db, 'TableState/GameState'), state);
    },
    setButtonState({commit},state){
      const db = getDatabase();
      set(ref(db, 'TableState/Armed'), state);
    },
    initiateState({commit},state){
      const db = getDatabase();
      set(ref(db, 'TableState/Armed'), false);
      set(ref(db, 'TableState/OSC_Status'), false);
      set(ref(db, 'TableState/BallIn'), false);

    },
    initiateListeners({ commit, dispatch}){
      var self=this
      const db = getDatabase();
        const tableActive = ref(db, 'TableState/Armed');
        onValue(tableActive, (snapshot) => {
          const data = snapshot.val(); 
          console.log("Armed",data)
          commit('setConnectionWEB',true)
        });
        const GameState = ref(db, 'TableState/GameState');
        onValue(GameState, (snapshot) => {
          const data = snapshot.val(); 
          console.log("GameState",data)
          commit('setGameState',data)
          commit('setConnectionWEB',true)
          if(data == "Waiting"){
            console.log("Update State",data)
            dispatch('getScores');
          }else{
            console.log("Update State",data)
          }
        });
        const OSC_Status = ref(db, 'TableState/OSC_Status');
        onValue(OSC_Status, (snapshot) => {
          const data = snapshot.val(); 
          console.log("OSC_Status",data)
          commit('setConnectionOSC',data)
          commit('setConnectionWEB',true)
        });
    },
    getScores({commit},payload){ 
      
      firebase.firestore().collection("LeaderBoard").orderBy("Name").get().then((query) => {  
        var scores=[]
        var names=[]
        var score
        commit('setTotalEntries',query.docs.length)
       
        for (var doc in query.docs){
          
          score=query.docs[doc].data()
          if(!score.inactive && !isNaN(score.score)){
          
            scores.push(score)
            names.push(score.Name)

          }else{
            console.log("ignoring",score.name)
          }
        }
       console.log("Scores updated")
        commit('setScores',scores)
        commit('setNames',names)
        
    }).catch(err => {
        console.log('Error logged', err);
      })
    },
    getLocations({commit},payload){ 
      firebase.firestore().collection("Locations").get().then((query) => {  
        var locs=[]
        var loc
        
        for (var doc in query.docs){
          loc=query.docs[doc].data()   
            locs.push(loc.name)
        }
        commit('setLocations',locs)
    }).catch(err => {
        console.log('Error logged', err);
      })
    },
    getSettings({commit},payload){ 
      firebase.firestore().collection("Settings").get().then((query) => {  
        var levels=[]
        var level
        var setting
        for (var doc in query.docs){
          var setting=query.docs[doc].data() 
          if(Object.keys(setting)[doc] == "levels"){
            console.log("Levels",setting.levels)
            commit('setLevels',setting.levels)
          }
          
            
        }
        //commit('setLocations',locs)
    }).catch(err => {
        console.log('Error logged', err);
      })
    },
    
    
    
   
    addLocation({commit},payload){
      firebase.firestore().collection("Locations").doc(payload).set({name:payload})
      .then(function() {
        console.log("Location successfully written!",payload);
        commit("addLocation",payload)
      })
      .catch(function(error) {
        console.error("Error writing document: ", error);
      });
    },
    
    addPlayer({commit,getters},payload){
      let id="000000"+getters.getTotalEntries
      id = "A"+id.slice(-6)+"_"+payload.Name
      payload.time=new Date()
      console.log(id)
      firebase.firestore().collection("LeaderBoard").doc(id).set(payload)
      .then(function() {
        commit('addPlayer',payload)
        console.log("Player successfully written!",payload);
        const db = getDatabase();
        set(ref(db, 'TableState/PlayerID'), id);
        //commit("addLocation",payload)
      })
      .catch(function(error) {
        console.error("Error writing document: ", error);
      });
    },
    
  },
  getters:{
    getConnectionWEB(state){
      return state.connectionWEB
    },
    getConnectionOSC(state){
      return state.connectionOSC
    },
    getGameState(state,){
     return  state.gameState
    },
    getScores(state){
      return state.scores
    },
    getNames(state){
      return state.names
    },
    getLocations(state){
      return state.locations
    },
    getLevels(state){
      return state.levels
    },
    getTotalEntries(state){
      return state.totalEntries
    }
    
  },
  modules: {
  }
})
